(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pletsi-novo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /** One controller per initialised section root; aborting it removes every listener. */
    const controllers = new WeakMap();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    /** @param {HTMLElement} root */
    const init = (root) => {
      if (controllers.has(root)) return;
      const controller = new AbortController();
      const { signal } = controller;
      controllers.set(root, controller);

      const tabs = [...root.querySelectorAll('.pletsi-novo__tab[role="tab"]')];
      const panels = root.querySelectorAll('.pletsi-novo__panel');
      const [prev, next] = root.querySelectorAll('.pletsi-novo__arrow');
      const activeRail = () => root.querySelector('.pletsi-novo__panel:not([hidden]) .pletsi-novo__rail');

      const updateArrows = () => {
        const rail = activeRail();
        if (!rail || !prev || !next) return;
        const focused = document.activeElement;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        // a disabled button drops focus; hand it to the other arrow instead
        if (focused === prev && prev.disabled && !next.disabled) next.focus();
        else if (focused === next && next.disabled && !prev.disabled) prev.focus();
      };

      // tabs (click + arrow / Home / End keys with a roving tabindex)
      const select = (tab) => {
        const panelId = tab.getAttribute('aria-controls');
        for (const t of tabs) {
          const selected = t === tab;
          t.setAttribute('aria-selected', String(selected));
          t.tabIndex = selected ? 0 : -1;
        }
        for (const p of panels) p.hidden = p.id !== panelId;
        const rail = activeRail();
        if (rail) rail.scrollLeft = 0;
        updateArrows();
      };
      for (const tab of tabs) tab.addEventListener('click', () => select(tab), { signal });
      root.querySelector('[role="tablist"]')?.addEventListener(
        'keydown',
        (e) => {
          const i = tabs.indexOf(e.target);
          if (i < 0) return;
          const keys = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 };
          if (!(e.key in keys)) return;
          e.preventDefault();
          const tab = tabs[(keys[e.key] + tabs.length) % tabs.length];
          select(tab);
          tab.focus();
        },
        { signal }
      );

      /** Scroll positions where each card's start meets the rail's gutter (the snap points). */
      const snapPoints = (rail) => {
        const railLeft = rail.getBoundingClientRect().left;
        const pad = parseFloat(getComputedStyle(rail).scrollPaddingInlineStart) || 0;
        const max = rail.scrollWidth - rail.clientWidth;
        const points = [...rail.querySelectorAll('.pletsi-novo__item')].map((item) =>
          Math.min(max, Math.max(0, rail.scrollLeft + item.getBoundingClientRect().left - railLeft - pad))
        );
        return [...new Set(points.map(Math.round))];
      };

      // arrows: land exactly on the next / previous card
      for (const btn of [prev, next]) {
        btn?.addEventListener(
          'click',
          () => {
            const rail = activeRail();
            if (!rail) return;
            const dir = Number(btn.dataset.dir);
            const points = snapPoints(rail);
            const target =
              dir > 0
                ? points.find((x) => x > rail.scrollLeft + 2)
                : points.findLast((x) => x < rail.scrollLeft - 2);
            if (target === undefined) return;
            rail.scrollTo({ left: target, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
          },
          { signal }
        );
      }

      // drag to scroll, then a quick eased snap to a card on release (mouse only; touch scrolls natively)
      for (const rail of root.querySelectorAll('.pletsi-novo__rail')) {
        let startX = 0, startLeft = 0, lastX = 0, lastT = 0, velocity = 0, moved = false, pressed = false, raf = 0;
        signal.addEventListener('abort', () => cancelAnimationFrame(raf));
        rail.addEventListener('scroll', updateArrows, { passive: true, signal });

        rail.addEventListener(
          'pointerdown',
          (e) => {
            if (e.pointerType !== 'mouse' || e.button !== 0) return;
            cancelAnimationFrame(raf);
            rail.classList.remove('is-dragging');
            startX = lastX = e.clientX;
            startLeft = rail.scrollLeft;
            lastT = performance.now();
            velocity = 0;
            moved = false;
            pressed = true;
          },
          { signal }
        );

        rail.addEventListener(
          'pointermove',
          (e) => {
            if (!pressed) return;
            const dx = e.clientX - startX;
            // only become a drag after a real movement, so a plain click still opens the product
            if (!moved && Math.abs(dx) > 6) {
              moved = true;
              rail.classList.add('is-dragging');
              rail.setPointerCapture(e.pointerId);
            }
            if (!moved) return;
            const now = performance.now();
            velocity = (e.clientX - lastX) / Math.max(1, now - lastT);
            lastX = e.clientX;
            lastT = now;
            rail.scrollLeft = startLeft - dx;
          },
          { signal }
        );

        const end = (e) => {
          if (!pressed) return;
          pressed = false;
          if (rail.hasPointerCapture(e.pointerId)) rail.releasePointerCapture(e.pointerId);
          if (!moved) return;

          // pick the card nearest to where the throw would land; a quick flick always moves one card
          const points = snapPoints(rail);
          const nearest = (x) =>
            points.reduce((best, p) => (Math.abs(p - x) < Math.abs(best - x) ? p : best), points[0]);
          const projected = rail.scrollLeft - velocity * 250;
          let target = nearest(projected);
          if (Math.abs(velocity) > 0.3 && target === nearest(rail.scrollLeft)) {
            const flick =
              velocity < 0
                ? points.find((x) => x > rail.scrollLeft + 2)
                : points.findLast((x) => x < rail.scrollLeft - 2);
            if (flick !== undefined) target = flick;
          }

          // is-dragging keeps native snapping and smooth scrolling off until we arrive on the card
          if (reducedMotion.matches || target === undefined) {
            if (target !== undefined) rail.scrollLeft = target;
            rail.classList.remove('is-dragging');
            return;
          }
          const from = rail.scrollLeft;
          const distance = target - from;
          const duration = Math.min(480, 220 + Math.abs(distance) * 0.3);
          const start = performance.now();
          const tick = (now) => {
            const t = Math.min(1, (now - start) / duration);
            rail.scrollLeft = from + distance * (1 - (1 - t) ** 3); // ease-out cubic
            if (t < 1) raf = requestAnimationFrame(tick);
            else rail.classList.remove('is-dragging');
          };
          raf = requestAnimationFrame(tick);
        };
        rail.addEventListener('pointerup', end, { signal });
        rail.addEventListener('pointercancel', end, { signal });
        // swallow the click that ends a drag
        rail.addEventListener(
          'click',
          (e) => {
            if (!moved) return;
            e.preventDefault();
            e.stopPropagation();
            moved = false;
          },
          { capture: true, signal }
        );
      }

      updateArrows();
      window.addEventListener('resize', updateArrows, { passive: true, signal });
    };

    /** @param {ParentNode} scope */
    const run = (scope) => scope.querySelectorAll('[data-pletsi-novo]').forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => run(document), { once: true });
    } else {
      run(document);
    }
    document.addEventListener('shopify:section:load', (e) => run(e.target));
    document.addEventListener('shopify:section:unload', (e) => {
      for (const root of e.target.querySelectorAll('[data-pletsi-novo]')) {
        controllers.get(root)?.abort();
        controllers.delete(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
